<div class="w-full p-16 flex flex-col gap-4 " *ngIf="form">
    <div class="form-subtitle">{{'PROJECT.MEMBERS.TITLE'| translate}}</div>
    <p *ngIf="isProject">{{'PROJECT.MEMBERS.LEGEND'| translate}}</p>
    <div class="w-full flex flex-col gap-2 padding-form">
        <!-- <mat-slide-toggle [checked]="all_customer" (change)="setAllCustomerValue($event)">{{ 'PROJECT.ALL_CUSTOMER'| translate}}</mat-slide-toggle> -->
        <mat-error *ngIf="no_range">{{ 'SELECT_A_RANGE' | translate }}</mat-error>
        <app-autocomplete-filter class="flex-grow" order="asc" [label]="'PROJECT.MEMBERS.LABEL'" [error]="'VALIDATORS.MEMBERS'" [placeholder]="'PROJECT.MEMBERS.FILTER_PLACEHOLDER'" [control]="filter_control" [options]="availableUserGroup" [filterKey]="['name', 'username', 'email']" [displayKey]="['name']" [secondaryDisplayKey]="['email']" [appearance]="'outline'" [local_filter]="false" [local_pagination]="member_pagination"
            [disabled]="locked"></app-autocomplete-filter>
    </div>
    <form class="flex flex-col w-full padding-form gap-4" [formGroup]="form">
        <!-- MEMBERLIST -->
        <div class="member-list border-2 border-tw-body-color p-4">
            <ng-container formArrayName="members">
                <div class="w-full grid grid-cols-9 gap-8 font-bold p-4">
                    <div></div>
                    <div class="flex">{{'PROJECT.MEMBERS.TABLE.NAME' | translate}}
                        
                    </div>
                    <div class="flex flex-col gap-2 items-center text-xs">
                        <div class="flex gap-2 items-center">
                            <span>{{'PROJECT.MEMBERS.TABLE.PROOFSCOPE' | translate}}</span>
                            <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.PROOFSCOPE' | translate}}">info</mat-icon>
                        </div>
                        <div class="flex gap-2">
                            <div class="w-1/2">{{'PROJECT.MEMBERS.TABLE.READ'|translate}}</div>
                            <div class="w-1/2">{{'PROJECT.MEMBERS.TABLE.WRITE'|translate}}</div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 items-center text-xs">
                        <div class="flex gap-2 items-center">
                            <span>{{'PROJECT.MEMBERS.TABLE.TEXTS' | translate}}</span>
                            <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.TEXTS' | translate}}">info</mat-icon>
                        </div>
                        <div class="flex gap-2">
                            <div class="w-1/2">{{'PROJECT.MEMBERS.TABLE.READ'|translate}}</div>
                            <div class="w-1/2">{{'PROJECT.MEMBERS.TABLE.WRITE'|translate}}</div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2 items-center text-xs">
                        <div class="flex gap-2 items-center">
                            <span>{{'PROJECT.MEMBERS.TABLE.APPROVERS' | translate}}</span>
                            <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.APPROBATION' | translate}}">info</mat-icon>
                        </div>
                        <div class="flex gap-2">
                            <div class="w-1/2">{{'PROJECT.MEMBERS.TABLE.INFO'|translate}}</div>
                            <div class="w-1/2">{{'PROJECT.MEMBERS.TABLE.DOCUMENT'|translate}}</div>
                        </div>
                    </div>
                    <div class="flex gap-2 justify-center text-xs">
                        <span>{{'PROJECT.MEMBERS.TABLE.VERSIONS' | translate}}</span>
                        <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.VERSIONS' | translate}}">info</mat-icon>
                    </div>
                    <div class="flex gap-2 justify-center text-xs">
                        <span>{{'PROJECT.MEMBERS.TABLE.EMAIL' | translate}}</span>
                        <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.EMAIL' | translate}}">info</mat-icon>
                    </div>
                    <div class="flex gap-2 justify-center text-xs">
                        <span> {{'PROJECT.MEMBERS.TABLE.PREEMPTIVE_RIGHT' | translate}}</span>
                        <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.PREEMPTIVE_RIGHT' | translate}}">info</mat-icon>
                    </div>
                    <div class="flex gap-2 justify-center text-xs">
                        <span>{{'PROJECT.MEMBERS.TABLE.ORDER' | translate}}</span>
                        <mat-icon class="text-tw-primary text-sm" matTooltip="{{'PROJECT.MEMBERS.TABLE.TOOLTIP.ORDER' | translate}}">info</mat-icon>
                    </div>
                    <ng-container *ngIf="members">
                        <ng-container *ngFor="let _ of members.controls; let i = index" [formGroupName]="i">
                            <div class="flex items-end">
                                <button (click)="removeMemberAt(i)" *ngIf="!locked">
                                    <mat-icon class="">remove_circle</mat-icon>
                                </button>
                            </div>
                            <div class="flex justify-center text-tw-primary">
                                <input matInput type="text" readonly formControlName="name">
                            </div>
                            <div class="flex flex-col gap-2 items-center">
                                <div class="flex gap-2">
                                    <div class="w-1/2">
                                        <mat-checkbox class="multiple-checkboxes proofscope-read-box" formControlName="hasProofscopeRead"></mat-checkbox>
                                    </div>
                                    <div class="w-1/2"> <mat-checkbox class="multiple-checkboxes proofscope-write-box" formControlName="hasProofscopeWrite"></mat-checkbox></div>
                                </div>
                            </div>
                            <div class="flex flex-col gap-2 items-center">
                                <div class="flex gap-2">
                                    <div class="w-1/2"><mat-checkbox class="multiple-checkboxes text-read-box" formControlName="hasTextRead"></mat-checkbox></div>
                                    <div class="w-1/2"><mat-checkbox class="multiple-checkboxes text-write-box" formControlName="hasTextWrite" [checked]="getMember(i).hasApproDocument"></mat-checkbox></div>
                                </div>
                            </div>
                            <div class="flex flex-col gap-2 items-center">
                                <div class="flex gap-2">
                                    <div class="w-1/2"><mat-checkbox class="multiple-checkboxes appro-info-box" formControlName="hasApproInfo"></mat-checkbox></div>
                                    <div class="w-1/2"><mat-checkbox class="multiple-checkboxes appro-document-box" formControlName="hasApproDocument"></mat-checkbox></div>
                                </div>
                            </div>
                            <div class="flex justify-center"><mat-checkbox class="version-read-box" formControlName="hasVersionRead"></mat-checkbox></div>
                            <div class="flex justify-center"> <mat-checkbox class="notification-box" formControlName="hasNotification"></mat-checkbox></div>
                            <div class="flex justify-center"><mat-checkbox class="notification-box" formControlName="hasPreemptiveRight"></mat-checkbox></div>
                            <div class="flex justify-center">
                                <input [ngClass]="{ 'hidden': !!(_ && _.value.hasApproDocument || locked) }" class="text-center border-dashed border-2 w-10 h-10 p-2" type="number" [max]="99" [min]="0" formControlName="order"/>
                                <p *ngIf="_ && !_.value.hasApproDocument && locked" class="text-center border-dashed border-2 w-10 h-10 p-2">{{ _.value.order }}</p>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div *ngIf="members.invalid" class="bg-orange-100 text-orange-400 p-4 rounded-md">
            <div *ngIf="members.errors?.['missingApproDoc']"> {{ 'PROJECT.MEMBERS.TABLE.ERROR.APPRODOC' | translate}} </div>
            <div *ngIf="members.errors?.['atleastOneApproInfo']"> {{ 'PROJECT.MEMBERS.TABLE.ERROR.ATLEASTONEINFO' | translate}} </div>
            <div *ngIf="members.errors?.['maximumOneApproDoc']"> {{ 'PROJECT.MEMBERS.TABLE.ERROR.MAXONE' | translate}} </div>
        </div>
    </form>
</div>